export const SIZES_MAP = {
  small: "12px",
  msmall: "16px",
  medium: "18px",
  // This is just temporary
  mlarge: "20px",
  large: "24px",
  xlarge: "30px",
  xxlarge: "36px",
  // Improve naming once we have a clearer view of all needed sizes
  huge: "64px"
} as const;

export const DEFAULT_SIZE = "medium";

export type SizeType = keyof typeof SIZES_MAP;
